import { useCallback, useEffect, useState } from 'react';
import { useDataSyncJobs } from 'src/components/star-grid/hooks/useDataSyncJobs';
import { useDataSyncText } from 'src/components/star-grid/hooks/useDataSyncText';
import { DataSyncScope } from 'src/components/star-grid/starGridTypes';
import { syncRequest, validateSyncForm } from 'src/components/star-grid/utils/dataSync';

export function useDataSyncView() {
  const data = useDataSyncJobs();
  const t = useDataSyncText();
  const [scope, setScope] = useState<DataSyncScope>('FULL');
  const [scenario, setScenario] = useState('0');
  const [fromMonth, setFromMonth] = useState('');
  const [toMonth, setToMonth] = useState('');
  const [formError, setFormError] = useState<string>();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!data.activeJob) return undefined;
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [data.activeJob?.id]);

  const startSync = useCallback(async (): Promise<void> => {
    if (!data.canTrigger) return;
    setFormError(undefined);
    const form = { scope, scenario, fromMonth, toMonth };
    const invalid = validateSyncForm(form);
    if (invalid) {
      setFormError(t(invalid));
      return;
    }
    try {
      await data.triggerSync(syncRequest(form));
    } catch (caught) {
      setFormError(caught instanceof Error ? caught.message : t('startFailed'));
    }
  }, [data.canTrigger, data.triggerSync, scope, scenario, fromMonth, toMonth, t]);

  return {
    ...data,
    t,
    scope,
    setScope,
    scenario,
    setScenario,
    fromMonth,
    setFromMonth,
    toMonth,
    setToMonth,
    formError,
    startSync,
    now
  };
}
